/**
 * Hub Search
 *
 * @returns {{init: init}}
 */
const HubSearch = (() => {
    const DOM = {};

    const cacheDOM = () => {
        DOM.select = document.getElementById("hubsearch");
    };

    const navigate = () => {
        const selectedValue = DOM.select.value;
        window.location.href = selectedValue;
    };

    const eventListener = () => {
        DOM.select.addEventListener("change", navigate);
    };

    const init = () => {
        cacheDOM();
        eventListener();
    };

    return {
        init,
    };
})();

export default HubSearch;
